import { useMutation } from "react-query";

import { IContestTerritoryPayload } from "~/entity/ContestTerritories/model/schema";

import { useContestTerritories } from "./useContestTerritories";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: IContestTerritoryPayload;
  /** uuid территории — при наличии выполняется PATCH, иначе POST. */
  id?: string;
  options?: MutateOptions;
}

export const useSaveContestTerritory = () => {
  const { createContestTerritory, updateContestTerritory } =
    useContestTerritories();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = props.id
        ? await updateContestTerritory(props.id, props.data)
        : await createContestTerritory(props.data);
      if (result) {
        return result;
      } else {
        throw new Error("Не удалось сохранить запись");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const save = (
    data: IContestTerritoryPayload,
    options?: MutateOptions,
    id?: string,
  ) => {
    mutation.mutate({ data, options, id });
  };

  return { save };
};
